export { GalleryWidget as default } from "@ecologi/react-components/src/GalleryWidget";
